<template>
  <div
    class="card card-plain shadow-none"
    id="sidenavCard"
  >
    <!-- <div class="p-3 card-body text-center w-100 pt-0">
      <img
        class="w-50 mx-auto"
        src="@/assets/img/illustrations/icon-documentation.svg"
        alt="sidebar_illustration"
      />
      <h6 class="mb-0 text-dark up">Manual de usuario</h6>
     
      <p class="text-xs font-weight-bold">Descargar Manual</p>
    </div> -->
    <a
      @click="cerrarsession()"
      class="mb-3 btn btn-danger btn-sm w-100"
      >Cerrar Session</a
    >
  </div>
</template>
<script>
import img from "../../assets/img/illustrations/icon-documentation.svg";

export default {
  name: "sidenav-card",
  data() {
    return {
      img
    };
  },
   methods:{
cerrarsession(){
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    this.$router.push("/");
    location.reload(true);
}
  },
};
</script>
